import useTranslation from "./useTranslation";

type WaitForTranslationsProps = {
  children: React.ReactNode;
};

export default function WaitForTranslations({
  children,
}: WaitForTranslationsProps) {
  const { ready } = useTranslation();

  if (!ready) {
    return null;
  }

  return <>{children}</>;
}
